const NAME = 'wheelchair';

const VIEWBOX = '0 0 500 500';

const CONTENTS = `
  <circle cx="250" cy="250" r="240"/>
  <g fill-rule="evenodd" clip-rule="evenodd" fill="#FFF">
    <path d="M202.07 122.75c16.76-1.55 29.78-16 29.78-32.87 0-18.18-14.83-33-33-33-18.18 0-33 14.82-33 33 0 5.54 1.54 11.2 4.12 15.98l11.76 165.46 121.1.04 49.68 116.38 65.23-25.58-10.1-24.04-36.5 13.17-48.06-110.98-112.6.76-1.54-20.96 81.5.03v-31l-84.6-.04z"/>
    <path d="M323.87 360.04c-20.44 40.4-63.22 67.03-108.86 67.03-67 0-121.67-54.67-121.67-121.7 0-47.05 28.52-90.8 71.08-110.17l2.77 35.94c-25.18 15.86-40.7 44.48-40.7 74.48 0 48.62 39.66 88.28 88.28 88.28 44.5 0 82.42-34.14 87.6-77.93z"/>
  </g>
`;

const SYMBOL_MARKUP = `<symbol id="tn-syos-seat-map-icon-${NAME}" viewBox="${VIEWBOX}">${CONTENTS}</symbol>`;

function getSvgMarkup(label = 'Wheelchair symbol within a circle') {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${VIEWBOX}" role="img" focusable="false" aria-label="${label}">${CONTENTS}</svg>`;
}


export default {
  getSvgMarkup,
  SYMBOL_MARKUP,
};



// WEBPACK FOOTER //
// ./src/syos/seatIcons/Wheelchair.js